import { createFileRoute } from "@tanstack/react-router";
import { McpStatsPage } from "@/features/connect-ai/mcp-stats-page";
import { mcpStatsSearchSchema } from "@/features/connect-ai/mcp-stats-search";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/mcp-statystyki")({
	validateSearch: (search) => mcpStatsSearchSchema.parse(search),
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.system.mcp-statystyki",
			location.pathname,
		);
	},
	component: McpStatsPage,
});
